import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { AttendanceService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-attdash',
  templateUrl: './attdash.component.html',
  styleUrls: ['./attdash.component.scss'],
  providers:[AttendanceService,MasterService]
})
export class AttdashComponent implements OnInit {

  bookdetails:any[];
  
    @ViewChild('dt') table: any;
    closeResult: string;
    modalOptions:NgbModalOptions;
    smmodalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    private smallmodalRef: NgbModalRef;
    booksmodel:any={};
    dashcount:any={};
    bookinfo:any={};
    oprtype:string;
    filtcatgory:any[];
    bindtypes:any[];
    laguages:any[];
    currency:any[];
    lsection=[];
    issuehis=[];
    arrnewar=[];
    selfield:any={};
    selpub:any={};
    selsup:any={};
    selsub:any={};
    //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
    tab=1;
    selcat:any=0;
    verifiedstatus:any;
    issuedetails:any={};
    bkcopies:any=1;
    clsdate:any=[];
    catwiseissued:any=[];
    arrdeptwisecollect:any=[];
    arrauthwisecollect:any=[];
    arrtitlewisecollect:any=[];
    arrsubjectwisecollect:any=[];
    arrpublisherwisecollect:any=[];
    arrsuplierwisecollect:any=[];
    arrsourcewisecollect:any=[];
    arrsectionwisecollect:any=[];
    arrpopcirculation:any=[]
    arraccndata:any=[];
    arractmember:any=[];
    arrcirdept:any=[];
    arrcirdate:any=[];
    arrcirmonth:any=[];
    arrfields:any=[];
    arracnseries:any=[];
    aldept:boolean=false;
    alsub:boolean=false;
    alsup:boolean=false;
    alsur:boolean=false;
    alsec:boolean=false;
    alpub:boolean=false;
    alcat:boolean=false;
    alacc:boolean=true;
    alauth:boolean=false;
    altitle:boolean=false;
    alnwarival:boolean=false;
    issuedinfocnt:any={};
    objqrprint:any={};
    objqrprintbulk:any={};
    objbkbulk:any={};
    nobc=1;
    frval='';
    toval='';
    qrdoctype='1UpQrcodeSpine';
    sertxt="";
  attdt: any;
  maxdt: string;
  classes: any;
  arratstu: any;
  arratstuabs: any;
  clid="0";
  attdt1: string;
 
    
    constructor(private http: HttpClient,private   mservice: MasterService, private liservice: AttendanceService,private modalService: NgbModal,private _global: AppGlobals) {
  
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'lg'
      }
      this.smmodalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'sm'
      }
     }
  
   
     public pieChartOptions: ChartOptions = {
      responsive: true,
      legend: {
          position: 'left',
        },
    };
   
    public catChartLabels: Label[] ;
    public catChartData: SingleDataSet ;
     public procureChartLabels: Label[] ;
     public procureChartData: SingleDataSet ;
     public procureChartType: ChartType = 'doughnut';
     public procureChartLegend = true;
     public procureChartPlugins = [];
     public procureChartColors: Color[] = [
       {backgroundColor:["#FF00CC","#0033FF","#99CC00","#FF3333","#FFFF66","#5EE8C6","#5EC2E8","#AF5EE8","#5EE8A1","#9505F9","#F9A005","#F90595","#BC3210","#A5E2ED"]},
       // {backgroundColor:["#9E120E","#FF5800","#FFB414"]},
       // {backgroundColor:["#9E120E","#FF5800","#FFB414"]}
     ];
      
     barChartOptions: ChartOptions = {
      responsive: true,
    };
    barChartLabels: Label[] = [];
    barChartType: ChartType = 'bar';
    barChartLegend = false;
    barChartPlugins = [];
    barChartColors: Color[] = [
      {
        
        backgroundColor: '#FF00CC',
      },
      {
       
        backgroundColor: '#0033FF',
      },
    ];
    barChartData: ChartDataSets[] = [
      // { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
    ];
    ngOnInit(): void {
      debugger
      // this.getattstfdash("2026-01-13");
       this.maxdt=this.liservice.getdatetoday();
      this.attdt=this.liservice.getdatetoday();
      this.attdt1=this.liservice.getdatetoday();
      this.getlastfewdates();
  
    }


     chartcatcirculation(charr)
  {
    
   
      // console.log('result',resultArray) ;
      // this.catwiseissued=resultArray;
  
     var arr = []
     var labelarr=[];
  
  
     for ( var i = 0; i < charr.length ; i++) {
      
       
            
      labelarr.push(charr[i].name);
           
      arr.push(parseInt( charr[i].cnt));    
           
    }
      
     
      this.catChartLabels = labelarr;
     this.catChartData = arr;
     
 
  }
   
  
   getattstfdash(obj) {
    if(obj.htag=='0')
    {
    this.attdt=obj.atdt;
    this.liservice.getattstfdash(obj.atdt)
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.issuedetails = resultArray.arrattstf;
            this.dashcount = resultArray.stfdashsum;

            const itemsArray: any[] = Object.entries(resultArray.stfdashsum).map(([key, value]) => ({
    name: key,
    cnt: value
}));
var chararray=itemsArray.slice(1);
console.log(chararray);
this.chartcatcirculation(chararray);
// console.log(itemsArray);
          //issuedbktomem  
          if(resultArray.arrattstf)
          {
          this.getlayoutdet(obj.atdt,resultArray.arrattstf[0]);
          }
          else 
          {
            this.arrpopcirculation=[];
          }
            
        },
        error => console.log("Error :: " + error)
        )
  }
  
  else
  {
     this.issuedetails =[];
            this.dashcount ={};
  }
   }

  getlayoutdet(atdt,obj) {
    debugger
    this.liservice.getattstfdashlayout(atdt,obj)
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.arrpopcirculation = resultArray.arrattstf;
           

            
            
        },
        error => console.log("Error :: " + error)
        )
  }

    getlastfewdates() {
    this.liservice.getlastfewdates()
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.arracnseries = resultArray.arrdates;
            this.getattstfdash(resultArray.arrdates[0].atdt);
           

            
            
        },
        error => console.log("Error :: " + error)
        )
  }
  
  
  openbulkdialog(content) {
  
  // this.generateaccnseeries(this.booksmodel.accno,this.bkcopies);
    
    
   var smallmodalOptions:NgbModalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'sm'
     
    }
    this.smallmodalRef=this.modalService.open(content,smallmodalOptions);
    
    this.smallmodalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  masclass() {
       this.mservice.masclass()
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.classes = resultArray;
              this.getattdashstudent(this.clid); 
              this.getattdashstudentabs(this.attdt1);
              
           },
           error => console.log("Error :: " + error)
           )
     }

     getattdashstudent(clid) {
    this.liservice.getattdashstudent(clid)
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.arratstu = resultArray;
           

            
            
        },
        error => console.log("Error :: " + error)
        )
  }

   getattdashstudentabs(atdt) {
    this.liservice.getattdashstudentabs(atdt)
        .subscribe(
        resultArray => {
            console.log('issueddata', resultArray);
            this.arratstuabs = resultArray;
           

            
            
        },
        error => console.log("Error :: " + error)
        )
  }

  
  }
  
